module.exports = __webpack_public_path__ + "static/media/autogas.68f45fd1.svg";